import React from 'react';
import { Col, Container, Row } from 'reactstrap';
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import CustomGameLevelType from './gameLevelTable';
export default function GameLevelList() {
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Breadcrumbs
            title='Dictionary'
            breadcrumbItem='Game Levels'
          />
          <Row>
            <Col className='col-12'>
              <CustomGameLevelType />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}
